import { useCallback, useState } from 'react'

import { useClickaway } from '@/hooks/useClickaway'
import { useNavItems } from '@/hooks/useNavItems'
import { getClickawayIgnoreProps } from '@/utils/clickawayUtil'
import { cn } from '@/utils/commonUtil'

import styles from './MenuNavMain.module.scss'
import { MenuNavMainButton } from './MenuNavMainButton/MenuNavMainButton'
import { MenuNavMainFlyin } from './MenuNavMainFlyin/MenuNavMainFlyin'

export const MenuNavMain = () => {
  const items = useNavItems(styles, 'mobile')
  const [openItem, setOpenItem] = useState<string | false>(false)

  const onClickAway = useCallback(() => setOpenItem(false), [])

  useClickaway({ ignore: 'nav-mobile', onClickAway })

  return (
    <nav className={styles.container} role='navigation' {...getClickawayIgnoreProps(['nav-mobile'])}>
      <ul className={cn(styles.menuMain, { hasOpen: !!openItem, styles })}>
        {items.submenu?.map((itemInner) => (
          <li
            className={cn(styles.itemMain, {
              isOpen: openItem === itemInner.id,
              styles,
            })}
            key={itemInner.id}
          >
            <MenuNavMainButton
              className={styles.buttonMain}
              item={itemInner}
              onClick={itemInner.submenu ? (id) => setOpenItem(id === openItem ? false : id) : undefined}
              showCaret
            />
            <MenuNavMainFlyin item={itemInner} />
          </li>
        ))}
      </ul>
    </nav>
  )
}
